var mulberrySelectors = {
  addToCart : '[data-add-to-cart]'
}

// var mbLoaded = false

// if (window.location.href.indexOf('/products') !== -1) {
//   var mbLoadedListener = setInterval(checkMbLoaded, 50)
  
//   function checkMbLoaded() {
//       if (!mbLoaded) {
//       	document.querySelector(mulberrySelectors.addToCart).addEventListener('click', async function() { 
//           if (!mbLoaded) {
//             setTimeout(async function() {
//             	await window.pdpModal.open()
//             }, 1400)
//           }
//       })
//      }	 
//     }
//  }

async function mulberryInit() {
	var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
    var product = response.product;
  	window.selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)
    
    window.offers = await mulberry.core.getWarrantyOffer({
       id: window.selectedVariant.id,
       title: product.title,
       price: window.selectedVariant.price,
       detail: product
   }) 
     
     window.pdpModal = await mulberry.modal.init({
      offers: window.offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async function(warranty) {
    		var result = await mulberryShop.getWarrantyVariant(warranty)
      		await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: window.selectedVariant.id}, warranty)
    		await removeAndSyncWarranties()
    		window.pdpModal.close()
            setCartInfo() 
            await mulberryShop.cart.init()
            mulberryShop.cart.render()
    	},
      onWarrantyDecline: async function() {
          await removeAndSyncWarranties()
          window.pdpModal.close()
          await mulberryShop.cart.init()
          mulberryShop.cart.render()
      }
    })
    
    
    document.querySelector(mulberrySelectors.addToCart).addEventListener('click', addWarrantyToCart)
  
    async function addWarrantyToCart() {
    	window.pdpModal.open()
        mulberryShop.cart.init()
//         setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 300);
//       	setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 550);
      	setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 850);
    }
		
// 	mbLoaded = true
//     clearInterval(mbLoadedListener)
	
	    if(window.offers.length === 0) {
         return
     }
}

   async function removeAndSyncWarranties() {
       await fetch('/cart.js', {
       credentials: 'same-origin',
       method: 'GET',
       headers: {
         'Content-Type': 'application/json',
         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
       }
     }).then(function (cart) {
       cart.json().then(function (firstCart) {
         mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
         .then(newCart => {
           mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second
           .then(newCart => {
             mulberryShop.cart.init()
             mulberryShop.cart.render()
     	 	$('.cart__detail-info').html(theme.Currency.formatMoney(newCart.total_price, theme.settings.moneyFormat));
            $('.cart-link__count').text(`${newCart.item_count}`)
            if (newCart.item_count == 0) {
            	$('#CartDrawer form').addClass('cart--empty')
            }
           })
         })
       });
     })
 }

	$('body').on('updateCart', async function() {
      await removeAndSyncWarranties()
      await mulberryShop.cart.init()
//       setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 300);
//       setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 550);
      setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 850);
    })

    function setCartInfo() {
      $("warranty-details").each(function(idx, item){$(item).remove()})
      document.querySelectorAll(".cart__item").forEach(function(item){

      variantId = item.getAttribute('data-cart-item-id').split(":")[0]
      item.setAttribute('data-mulberry-variant-id', variantId)
      var $newWarrantyDetails = $("<warranty-details/>").attr('data-variant-id', variantId)
      
      $(item).find('[data-warranty-span]').append($newWarrantyDetails)
    }) 
  }

    document.addEventListener('mulberry-shopify:warranty-added', async function() {
        await mulberryShop.cart.init()
    	await removeAndSyncWarranties()
// 		setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 300);
//       	setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 550);
      	setTimeout(function(){ setCartInfo(); mulberryShop.cart.render() }, 850);
    })

 document.addEventListener('mulberry-shopify:loaded', async function() {
    if (window.location.href.indexOf('/products') !== -1) {
      	await mulberryInit()
        await mulberryShop.cart.init()
    	await mulberryShop.cart.render()
    } else {
    	await mulberryShop.cart.init()
    	await mulberryShop.cart.render()
    }
 })
   
